import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils';
import _ from 'lodash';

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    trainingModuleList: [],
    isDetailsFetched: false,
    trainingModuleDetails: "",
    isNewTrainingModuleAdded: false,
    trainingModuleTasksOptions: [],
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //  TRAINING MODULE LIST
    case `${events.GET_TRAINING_MODULE_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.trainingModuleList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_TRAINING_MODULE_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            trainingModuleList: [...state.trainingModuleList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_TRAINING_MODULE_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    // GET TRAINING MODULE DETAILS
    case `${events.GET_TRAINING_MODULE_DETAILS}_PENDING`: {
        return {
            ...state,
            trainingModuleDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_TRAINING_MODULE_DETAILS}_FULFILLED`: {
        return {
            ...state,
            trainingModuleDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_TRAINING_MODULE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }

    // ACTIVATE TRAINING MODULE
    case `${events.ACTIVATE_TRAINING_MODULE}_PENDING`: {
        return {
            ...state,
            isTMActivated: 'PENDING',
        };
    }
    case `${events.ACTIVATE_TRAINING_MODULE}_FULFILLED`: {
        if(action.payload.data.status === 'a') {
            showSuccess("Activated successfully")
        }
        
        return {
            ...state,
            isTMActivated: 'FULFILLED',
        };
    }
    case `${events.ACTIVATE_TRAINING_MODULE}_REJECTED`: {
        showError(action.payload.response.data.error)
        return {
            ...state,
            isTMActivated: 'REJECTED',
        };
    }

    // DELETE TRAINING MODULE
    case `${events.DELETE_TRAINING_MODULE}_PENDING`: {
        return {
            ...state,
            isTMDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_TRAINING_MODULE}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isTMDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_TRAINING_MODULE}_REJECTED`: {
        return {
            ...state,
            isTMDeleted: 'REJECTED',
        };
    }


    // GET TRAINING MODULE DETAILS BG
    case `${events.GET_TRAINING_MODULE_DETAILS_BG}_PENDING`: {
        return {
            ...state,
            isTMFetchBG: 'PENDING',
        };
    }
    case `${events.GET_TRAINING_MODULE_DETAILS_BG}_FULFILLED`: {
        return {
            ...state,
            trainingModuleDetails: action.payload.data,
            isTMFetchBG: 'FULFILLED',
        };
    }
    case `${events.GET_TRAINING_MODULE_DETAILS_BG}_REJECTED`: {
        return {
            ...state,
            isTMFetchBG: 'REJECTED',
        };
    }

    // ADD NEW TRAINING MODULE
    case `${events.ADD_NEW_TRAINING_MODULE}_PENDING`: {
        return {
            ...state,
            isNewTrainingModuleAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_TRAINING_MODULE}_FULFILLED`: {
        showSuccess("New training module added")
        return {
            ...state,
            isNewTrainingModuleAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_TRAINING_MODULE}_REJECTED`: {
        return {
            ...state,
            isNewTrainingModuleAdded: 'REJECTED',
        };
    }

    // SAVE NEW TRAINING MODULE
    case `${events.SAVE_TRAINING_MODULE_DETAILS}_PENDING`: {
        return {
            ...state,
            isTrainingModuleSaved: 'PENDING',
        };
    }
    case `${events.SAVE_TRAINING_MODULE_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isTrainingModuleSaved: 'FULFILLED',
        };
    }
    case `${events.SAVE_TRAINING_MODULE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isTrainingModuleSaved: 'REJECTED',
        };
    }

    // CREATE ARTICLE
    case `${events.CREATE_ARTICLE}_PENDING`: {
        return {
            ...state,
            isArticleCreated: 'PENDING',
        };
    }
    case `${events.CREATE_ARTICLE}_FULFILLED`: {
        showSuccess("New article created successfully")
        return {
            ...state,
            isArticleCreated: 'FULFILLED',
        };
    }
    case `${events.CREATE_ARTICLE}_REJECTED`: {
        return {
            ...state,
            isArticleCreated: 'REJECTED',
        };
    }

    // UPDATE ARTICLE
    case `${events.UPDATE_ARTICLE}_PENDING`: {
        return {
            ...state,
            isArticleUpdated: 'PENDING' + action.meta.articleId,
        };
    }
    case `${events.UPDATE_ARTICLE}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isArticleUpdated: 'FULFILLED' + action.meta.articleId,
        };
    }
    case `${events.UPDATE_ARTICLE}_REJECTED`: {
        return {
            ...state,
            isArticleUpdated: 'REJECTED' + action.meta.articleId,
        };
    }

    // DELETE ARTICLE
    case `${events.DELETE_ARTICLE}_PENDING`: {
        return {
            ...state,
            isArticleDeleted: 'PENDING' + action.meta.articleId,
        };
    }
    case `${events.DELETE_ARTICLE}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isArticleDeleted: 'FULFILLED' + action.meta.articleId,
        };
    }
    case `${events.DELETE_ARTICLE}_REJECTED`: {
        return {
            ...state,
            isArticleDeleted: 'REJECTED' + action.meta.articleId,
        };
    }

    // CREATE TASK
    case `${events.CREATE_TASK}_PENDING`: {
        return {
            ...state,
            isTaskCreated: 'PENDING',
        };
    }
    case `${events.CREATE_TASK}_FULFILLED`: {
        showSuccess("New task created successfully")
        return {
            ...state,
            isTaskCreated: 'FULFILLED',
        };
    }
    case `${events.CREATE_TASK}_REJECTED`: {
        return {
            ...state,
            isTaskCreated: 'REJECTED',
        };
    }

    // UPDATE TASK
    case `${events.UPDATE_TASK}_PENDING`: {
        return {
            ...state,
            isTaskUpdated: 'PENDING' + action.meta.taskId,
        };
    }
    case `${events.UPDATE_TASK}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isTaskUpdated: 'FULFILLED' + action.meta.taskId,
        };
    }
    case `${events.UPDATE_TASK}_REJECTED`: {
        return {
            ...state,
            isTaskUpdated: 'REJECTED' + action.meta.taskId,
        };
    }

    // CREATE TM QUESTIONNAIRE
    case `${events.CREATE_TM_QUESTIONNAIRE}_PENDING`: {
        return {
            ...state,
            isTMQCreated: 'PENDING',
        };
    }
    case `${events.CREATE_TM_QUESTIONNAIRE}_FULFILLED`: {
        showSuccess("New questionnaire added successfully")
        return {
            ...state,
            isTMQCreated: 'FULFILLED',
        };
    }
    case `${events.CREATE_TM_QUESTIONNAIRE}_REJECTED`: {
        return {
            ...state,
            isTMQCreated: 'REJECTED',
        };
    }

    // UPDATE TM QUESTIONNAIRE
    case `${events.UPDATE_TM_QUESTIONNAIRE}_PENDING`: {
        return {
            ...state,
            isTMQUpdated: 'PENDING' + action.meta.quesId,
        };
    }
    case `${events.UPDATE_TM_QUESTIONNAIRE}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isTMQUpdated: 'FULFILLED' + action.meta.quesId,
        };
    }
    case `${events.UPDATE_TM_QUESTIONNAIRE}_REJECTED`: {
        return {
            ...state,
            isTMQUpdated: 'REJECTED' + action.meta.quesId,
        };
    }

    // DELETE TM QUESTIONNAIRE
    case `${events.DELETE_TM_QUESTIONNAIRE}_PENDING`: {
        return {
            ...state,
            isTMQDelete: 'PENDING' + action.meta.quesId,
        };
    }
    case `${events.DELETE_TM_QUESTIONNAIRE}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isTMQDelete: 'FULFILLED' + action.meta.quesId,
        };
    }
    case `${events.DELETE_TM_QUESTIONNAIRE}_REJECTED`: {
        return {
            ...state,
            isTMQDelete: 'REJECTED' + action.meta.quesId,
        };
    }

    // DELETE TM TASK
    case `${events.DELETE_TM_TASK}_PENDING`: {
        return {
            ...state,
            isTMTaskDeleted: 'PENDING' + action.meta.taskId,
        };
    }
    case `${events.DELETE_TM_TASK}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isTMTaskDeleted: 'FULFILLED' + action.meta.taskId,
        };
    }
    case `${events.DELETE_TM_TASK}_REJECTED`: {
        return {
            ...state,
            isTMTaskDeleted: 'REJECTED' + action.meta.taskId,
        };
    }

    // DELETE TM TASK
    case `${events.TASK_IMAGE_UPLOAD}_PENDING`: {
        return {
            ...state,
            isTMTaskImageUploaded: 'PENDING' + action.meta.taskId + action.meta.type,
        };
    }
    case `${events.TASK_IMAGE_UPLOAD}_FULFILLED`: {
        showSuccess("Image uploaded successfully")
        return {
            ...state,
            isTMTaskImageUploaded: 'FULFILLED' + action.meta.taskId,
        };
    }
    case `${events.TASK_IMAGE_UPLOAD}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isTMTaskImageUploaded: 'REJECTED' + action.meta.taskId,
        };
    }

    // GET TM TASKS
    case `${events.GET_TRAINING_MODULE_TASKS}_PENDING`: {
        return {
            ...state,
            trainingModuleTasksOptions: [],
            isGetTrainingModuleTasks: 'PENDING',
        };
    }
    case `${events.GET_TRAINING_MODULE_TASKS}_FULFILLED`: {
        var options = []
        action.payload.data.map((d) => {
            options.push({
                label: d.title + ' (' + d.module.title + ')',
                value: d.uuid
            })
        })
        
        return {
            ...state,
            trainingModuleTasksOptions: _.uniqBy(options, 'value'),
            isGetTrainingModuleTasks: 'FULFILLED',
        };
    }
    case `${events.GET_TRAINING_MODULE_TASKS}_REJECTED`: {
        return {
            ...state,
            isGetTrainingModuleTasks: 'REJECTED',
        };
    }
    

    default:
        return state;
    }
}
